export default "__VITE_ASSET__DzYnoPff__"